import { styled, SxProps, Theme, Typography } from "@/common/styles/style";
import theme from "@/common/styles/theme";

export const styles: { [key: string]: SxProps<Theme> } = {
  cursorDefault: {
    cursor: "default",
  },
  alignCenter: {
    alignItems: "center",
  },
  popover: {
    zIndex: 2000,
  },
  popoverMenu: {
    padding: "8px 16px",
  },
  logo: {
    "&:focus": {
      outline: "none",
    },
    "&:active": {
      outline: "none",
    },
  },
};

export const TopBox = styled("div")({
  top: 0,
  backgroundColor: "#fff",
  width: "100%",
  height: "50px",
  position: "fixed",
  left: 0,
  zIndex: 1000,
  alignItems: "center",
  justifyContent: "space-between",
  display: "flex",
  padding: "0 2rem",
  boxSizing: "border-box",
});

export const HeaderBox = styled("div")({
  top: 50,
  backgroundColor: theme.palette.primary.main,
  color: "#fff",
  width: "100%",
  height: "50px",
  position: "fixed",
  left: 0,
  zIndex: 1000,
  alignItems: "center",
  justifyContent: "space-between",
  boxSizing: "border-box",
  display: "flex",
  padding: "0 2rem",
});

export const CustomTypography = styled(Typography)({
  fontSize: "17px",
  cursor: "pointer",
});

function stringToColor(string: string) {
  if (!string) {
    return "#000000";
  }

  let hash = 0;
  let i;

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }

  return color;
}

export function stringAvatar(name: string) {
  if (!name) {
    name = "User";
  }
  const nameParts = name.split(" ");
  const firstName = nameParts[0][0].toUpperCase();
  const lastName = nameParts[1] ? nameParts[1][0].toUpperCase() : "";

  return {
    sx: {
      bgcolor: stringToColor(name),
      width: 35,
      height: 35,
      fontSize: 15,
    },
    children: `${firstName}${lastName}`,
  };
}
